var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[_c('v-form-base',{attrs:{"model":_vm.variant,"schema":_vm.formSchema},on:{"input":(input) => _vm.variant = input.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }